module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/bg-desempeno.7cb68116.svg";